import axios, {
  RawAxiosRequestConfig,
  AxiosInstance,
  RawAxiosRequestHeaders,
} from 'axios'
import {TARGET_DEFAULT_NAMESPACE} from '../../config'

export interface RequestConfig extends RawAxiosRequestConfig {
  baseURL: string
}

export type HttpInstance = AxiosInstance

interface CreateHttpInstance {
  (params: RequestConfig): HttpInstance
}

export const createHttpInstance: CreateHttpInstance = ({
  baseURL,
  ...params
}) => {
  let httpHeaders: RawAxiosRequestHeaders = {
    Accept: 'application/json',
  }

  if (TARGET_DEFAULT_NAMESPACE) {
    httpHeaders = {
      ...httpHeaders,
      'Target-Default-Namespace': TARGET_DEFAULT_NAMESPACE,
    }
  }

  return axios.create({
    baseURL,
    timeout: 15000,
    headers: httpHeaders,
    withCredentials: true,
    ...params,
  })
}
